import { development, test } from "./environments";

const macs365Test = '575qdh9ejvdfarkfi5f3n0q5r1';
const macs365Production = '1s9mj5pn8pndeiv5vublduae73';

const schwarzwaldTest = '30htlttjrbu3ghg8igjr42lqcf';
const schwarzwaldProduction = '';

const macsDIATest = 'ln28g5ipn0udr2jvf0md5vrfd';
const macsDIAProduction = '6hqb4jmh0s74d6cqjgf5f62irc';

const defaultTest = '4q68jks557dq1cem1bevdkrire';
const defaultProduction = '3cf5cglta495p0a8hs3dabqq3o';

export const macs365ClientId = development || test ? macs365Test : macs365Production;
export const defaultClientId = development || test ? defaultTest : defaultProduction;
export const macsDIAClientId = development || test ? macsDIATest : macsDIAProduction;
export const schwarzwaldClientId = development || test ? schwarzwaldTest: schwarzwaldProduction;
